import React from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, FileSyncOutlined } from '@ant-design/icons';
import ProformaList from '../../components/Proforma/ProformaList';
import ProformaSummary from '../../components/Proforma/ProformaSummary';

const { Title } = Typography;

const ProformaPage = () => {
    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <FileSyncOutlined />
                                <span>Proforma Invoices</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: '24px' }}>
                <Title level={2}>Proforma Invoices</Title>
            </div>

            <ProformaSummary />
            <ProformaList />
        </div>
    );
};


export default ProformaPage;
